import React from 'react';
import Icon from '../Icon';
import './style.css';

const MAX_TIMEOUT = 500; // in milliseconds

class Notification extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      unmounting: false,
      unmounted: !props.active || false
    };
  }

  componentDidUpdate(prevProps) {
    const { active: PrevActive } = prevProps;
    const { active: NewActive } = this.props;

    if (PrevActive !== NewActive && !NewActive) {
      this.removeNotification();
    }

    if (PrevActive !== NewActive && NewActive) {
      this.resetNotification();
    }
  }

  resetNotification = () => {
    this.setState({
      unmounted: false
    });
  };

  removeNotification = () => {
    this.setState({
      unmounting: true
    });

    setTimeout(() => {
      this.setState({
        unmounting: false,
        unmounted: true
      });
    }, MAX_TIMEOUT);
  };

  getAnimationClass = () => {
    const { unmounting } = this.state;
    let classname = '';
    if (unmounting) {
      classname += 'notification-card-out';
    } else {
      classname += 'notification-card-in';
    }

    return classname;
  };

  render() {
    const { onClose, title, description } = this.props;
    const { unmounted } = this.state;
    const animationClass = this.getAnimationClass();
    return !unmounted ? (
      <div className={`notification-card ${animationClass}`}>
        <button onClick={onClose}>
          <Icon name="fas fa-times" style={{ marginRight: '5px' }} />
        </button>
        <p>{title}</p>
        <pre>{description}</pre>
      </div>
    ) : null;
  }
}

export default Notification;



// WEBPACK FOOTER //
// ./src/Components/Notification/Notification.js